import { render, staticRenderFns } from "./import-coda-modal.vue?vue&type=template&id=3c683f50&scoped=true&"
import script from "./import-coda-modal.vue?vue&type=script&lang=ts&"
export * from "./import-coda-modal.vue?vue&type=script&lang=ts&"
import style0 from "./import-coda-modal.vue?vue&type=style&index=0&id=3c683f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c683f50",
  null
  
)

export default component.exports